const WriterLevels = {
  JUNIOR: 'Junior',
  SENIOR: 'Senior',
  PREMIUM: 'Premium',
};

module.exports = WriterLevels;
